import { useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/marketing/Landing";

export default function Home() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-sand-100 grid place-items-center">
        <div className="h-10 w-10 rounded-full border-4 border-terracotta-500 border-t-transparent animate-spin" />
      </div>
    );
  }

  if (user === false) return <Landing />;

  return (
    <AppLayout>
      <Dashboard />
    </AppLayout>
  );
}
